
export default function CardComponent(props) {
return (
    <div className="container my-3">
        <div className="row align-items-center h-100">
            <div className="col">
	            <div className="card mb-3 border-primary">
	                <div className="card-header">
                        <h2>Welcome</h2>
	                </div>
	                <div className="card-body">
                        <span className="card-text">to my little hobbyist development corner. This site is not intended to be used as a primary means for anything.<br />
                        This is a private development corner for me to host my pet-projects and, if desired, share my creations for personal growth.<br /><br />
                        That being said, all I ask from you is to provide feedback on code if you have it, give me a heads up if you want to use this site in a project/post, and overall work to make me better.<br />
                        See the tools menu at the top for links to my projects and the guides links for some guides made by some amazing people for 3ds hacking.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
}